import { MutationHookOptions, useMutation } from '@apollo/client';
import gql from 'graphql-tag';

// GraphQL mutation
const CHECK_AND_UPDATE_STREAK_ON_LOAD_MUTATION = gql`
  mutation checkAndUpdateStreakOnLoad($userId: String!) {
    checkAndUpdateStreakOnLoad(userId: $userId) {
      _id
      userId
      currentStreak
      longestStreak
      lastUpdatedAt
      history {
        streakCount
        earnedAt
        seen
      }
    }
  }
`;

// Input types for TypeScript
export interface CheckAndUpdateStreakOnLoadMutationType {
  checkAndUpdateStreakOnLoad: {
    _id: string;
    userId: string;
    currentStreak: number;
    longestStreak: number;
    lastUpdatedAt?: string;
    history: {
      streakCount: number;
      earnedAt: string;
      seen?: boolean;
    }[];
  };
}

export interface CheckAndUpdateStreakOnLoadMutationVariables {
  userId: string;
}

// Custom hook
export function useCheckAndUpdateStreakMutation(
  options?: MutationHookOptions<
    CheckAndUpdateStreakOnLoadMutationType,
    CheckAndUpdateStreakOnLoadMutationVariables
  >,
) {
  return useMutation<
    CheckAndUpdateStreakOnLoadMutationType,
    CheckAndUpdateStreakOnLoadMutationVariables
  >(CHECK_AND_UPDATE_STREAK_ON_LOAD_MUTATION, options);
}
